import { AccountManagement } from "@/interfaces/accountManagement";
import { HttpQuery } from "@/interfaces/httpQuery";
import { Location } from "@/interfaces/location";
import { policyList } from "@/internal";
import { LocationTableMetadata } from "@/metadata/location";
import { messagesService } from "@/services/messages.service";
import { LOCATION_SERVICE } from "@/services/refactor/location.service";
import { Callback } from "@/types/types";
import { INITIAL_QUERY_STATE } from "@/utils/constants";
import {
  ActionsSubheaderComponent,
  BooleanCheck,
  TableAction,
  TableComponent,
  TableHeader,
  TablePagination
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Template from "./LocationList.template.vue";

@Component({
  mixins: [Template],
  components: {
    TableComponent,
    ActionsSubheaderComponent
  }
})
export default class LocationListComponent extends Vue {
  @Getter("hasPermission", { namespace: "authModule" })
  public hasPermission!: BooleanCheck;
  @Getter("availability", { namespace: "AccountManagementModule" })
  public availability!: AccountManagement.Account;
  public viewPermission: boolean = false;
  public editPermission: boolean = false;
  @Action("loadAvailability", { namespace: "AccountManagementModule" })
  protected loadAvailability!: Callback;

  protected userService = LOCATION_SERVICE;
  protected locations: Location[] = [];
  protected pagination: TablePagination | null = null;
  protected loading = true;
  protected generalActions = LOCATION_SERVICE.getGeneralActions();
  protected rowActions!: TableAction[];
  protected headers: TableHeader[] = LocationTableMetadata;
  protected colors = ["white", "#f2f2f2", "#f2f2f2"];
  protected query: HttpQuery = INITIAL_QUERY_STATE;

  /**
   * Update requests on column name click to sort.
   * @param header: TableHader
   */
  public filter(header: TableHeader) {
    this.triggerSearch({
      ...INITIAL_QUERY_STATE,
      sort: LOCATION_SERVICE.sortQuery(header)
    });
  }

  /**
   * Update requests on table page change event.
   * @param pagination: TablePagination
   */
  public onChangePage(pagination: TablePagination) {
    this.triggerSearch({
      sort: this.query.sort,
      page: pagination.currentPage,
      per_page: pagination.itemsPerPage
    });
  }
  public mounted() {
    this.viewPermission = this.hasPermission(policyList.viewLocations);
    this.editPermission = this.hasPermission(policyList.modifyLocations);
    this.rowActions = LOCATION_SERVICE.getRowActions(
      this.viewPermission,
      this.editPermission
    );
  }

  private created() {
    this.loadAvailability();
    this.triggerSearch();
  }

  private async triggerSearch(query?: HttpQuery) {
    this.loading = true;
    this.query = query || this.query;
    try {
      this.locations = await LOCATION_SERVICE.getLocations(this.query);
      this.pagination = await LOCATION_SERVICE.getPagination();
    } catch (error) {
      messagesService.renderErrorMessage(error);
    } finally {
      this.loading = false;
    }
  }
}
